import { render, staticRenderFns } from "./reserve-list.vue?vue&type=template&id=727ff967&scoped=true&"
import script from "./reserve-list.vue?vue&type=script&lang=js&"
export * from "./reserve-list.vue?vue&type=script&lang=js&"
import style0 from "./reserve-list.vue?vue&type=style&index=0&id=727ff967&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727ff967",
  null
  
)

export default component.exports